import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback, useState } from 'react';
import { MediasPickerContainer, MediasBrowserContainer } from '@panneau/medias';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { useStory } from '@micromag/core/contexts';
import { useApi, useMediaCreate } from '@micromag/data';
import { FormattedMessage } from 'react-intl';
import { useUrlGenerator } from '@folklore/routes';

var defaultColumns = [{
  id: 'image',
  label: null,
  component: 'image',
  path: 'thumbnail_url',
  sortable: false
}, {
  id: 'name',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "WX83V9",
    defaultMessage: [{
      "type": 0,
      "value": "File name"
    }]
  }),
  component: 'text-description',
  path: 'name',
  descriptionPath: 'type',
  descriptionValues: {
    image: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "AwDQvD",
      defaultMessage: [{
        "type": 0,
        "value": "Image"
      }]
    }),
    video: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "mQiyAm",
      defaultMessage: [{
        "type": 0,
        "value": "Video"
      }]
    }),
    audio: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "XnyI69",
      defaultMessage: [{
        "type": 0,
        "value": "Audio"
      }]
    }),
    document: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "1dqmFw",
      defaultMessage: [{
        "type": 0,
        "value": "Document"
      }]
    })
  },
  sortable: true
}, {
  id: 'dimensions',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "eCe9ZY",
    defaultMessage: [{
      "type": 0,
      "value": "Dimensions"
    }]
  }),
  component: 'unit',
  format: 'dimensions',
  path: 'metadata'
}, {
  id: 'size',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "c3hu9o",
    defaultMessage: [{
      "type": 0,
      "value": "Size"
    }]
  }),
  component: 'unit',
  format: 'bytes',
  path: 'metadata.size'
}, {
  id: 'duration',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "002oWQ",
    defaultMessage: [{
      "type": 0,
      "value": "Duration"
    }]
  }),
  component: 'unit',
  format: 'duration',
  path: 'metadata.duration'
},
// {
//     id: 'author',
//     label: <FormattedMessage defaultMessage="Added by" description="Field name" />,
//     component: 'avatar',
//     path: 'metadata.author',
//     namePath: 'name',
//     withoutName: true,
// },
{
  id: 'created_at',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "OzYWZz",
    defaultMessage: [{
      "type": 0,
      "value": "Created at"
    }]
  }),
  component: 'date',
  path: 'created_at',
  format: 'yyyy-MM-dd hh:ss',
  sortable: true
}, {
  id: 'actions',
  label: /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "rtwfuZ",
    defaultMessage: [{
      "type": 0,
      "value": "Actions"
    }]
  }),
  actions: ['edit', 'delete']
  // component: ItemActions,
  // label: 'Edit',
  // url: '/edit/1',
}
// {
//     id: 'status',
//     label: <FormattedMessage defaultMessage="Status" description="Field name" />,
//     component: 'text',
//     path: 'metadata.status',
// },
];

function fields() {
  var route = useUrlGenerator();
  return [{
    name: 'name',
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "WX83V9",
      defaultMessage: [{
        "type": 0,
        "value": "File name"
      }]
    }),
    type: 'text',
    component: 'text'
  }, {
    id: 'metadata',
    component: 'fields',
    name: 'metadata',
    fields: [{
      name: 'description',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "ygNvmz",
        defaultMessage: [{
          "type": 0,
          "value": "Description"
        }]
      }),
      type: 'text',
      component: 'text'
    }, {
      name: 'tags',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "IOVper",
        defaultMessage: [{
          "type": 0,
          "value": "Tags"
        }]
      }),
      createPrefix: 'Create',
      type: 'array',
      component: 'item',
      requestUrl: route('medias.tags') || '/medias/tags',
      itemLabelPath: 'name',
      itemDescriptionPath: null,
      itemValuePath: 'id',
      // Uses taggable so change the logic here
      valueIsOption: true,
      multiple: true,
      paginated: false,
      creatable: true
    }]
  }, {
    id: 'info',
    component: 'fields',
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "3RT69u",
      defaultMessage: [{
        "type": 0,
        "value": "Informations"
      }]
    }),
    isList: true,
    hideWithoutValue: true,
    fields: [{
      id: 'user',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "yByaBh",
        defaultMessage: [{
          "type": 0,
          "value": "Added by"
        }]
      }),
      type: 'display',
      display: 'avatar',
      name: 'user',
      horizontal: true
    }, {
      id: 'created_at',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "PN+75e",
        defaultMessage: [{
          "type": 0,
          "value": "Created at"
        }]
      }),
      type: 'display',
      display: 'date',
      name: 'created_at',
      format: 'yyyy-MM-dd hh:ss',
      horizontal: true
    }]
  }, {
    id: 'technical',
    component: 'fields',
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "xKUOLG",
      defaultMessage: [{
        "type": 0,
        "value": "Technical details"
      }]
    }),
    isList: true,
    hideWithoutValue: true,
    fields: [{
      id: 'format',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "JuxiUN",
        defaultMessage: [{
          "type": 0,
          "value": "Format"
        }]
      }),
      type: 'display',
      display: 'unit',
      format: 'format',
      name: 'format',
      horizontal: true
    }, {
      id: 'dimensions',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "rmJBin",
        defaultMessage: [{
          "type": 0,
          "value": "Dimensions"
        }]
      }),
      type: 'display',
      display: 'unit',
      format: 'dimensions',
      name: 'metadata',
      horizontal: true
    }, {
      id: 'size',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "g2CRt5",
        defaultMessage: [{
          "type": 0,
          "value": "Size"
        }]
      }),
      type: 'display',
      display: 'unit',
      format: 'bytes',
      name: 'metadata.size',
      horizontal: true
    }, {
      id: 'duration',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "wU++NJ",
        defaultMessage: [{
          "type": 0,
          "value": "Duration"
        }]
      }),
      type: 'display',
      display: 'unit',
      format: 'duration',
      name: 'metadata.duration',
      horizontal: true
    }]
  }, {
    id: 'conversion',
    component: 'fields',
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "pBNrdH",
      defaultMessage: [{
        "type": 0,
        "value": "Conversion"
      }]
    }),
    isList: true,
    hideWithoutValue: true,
    fields: [{
      id: 'h264',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "4RV6+9",
        defaultMessage: [{
          "type": 0,
          "value": "H264"
        }]
      }),
      type: 'text',
      component: 'text',
      name: 'files.h264.url',
      horizontal: true
    }, {
      id: 'webm',
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "3I2Xl7",
        defaultMessage: [{
          "type": 0,
          "value": "WebM"
        }]
      }),
      type: 'text',
      component: 'text',
      name: 'files.webm.url',
      horizontal: true
    }]
  }];
}

function filters() {
  var route = useUrlGenerator();
  return [{
    id: 'search',
    component: 'search',
    name: 'search',
    width: 152
  }, {
    id: 'types',
    component: 'select',
    name: 'types',
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "9/t5wK",
      defaultMessage: [{
        "type": 0,
        "value": "Type"
      }]
    }),
    options: [{
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "yHAmDD",
        defaultMessage: [{
          "type": 0,
          "value": "Image"
        }]
      }),
      value: 'image'
    }, {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "xSERPA",
        defaultMessage: [{
          "type": 0,
          "value": "Video"
        }]
      }),
      value: 'video'
    }, {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "yQRtgx",
        defaultMessage: [{
          "type": 0,
          "value": "Audio"
        }]
      }),
      value: 'audio'
    }, {
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "fpQzza",
        defaultMessage: [{
          "type": 0,
          "value": "Font"
        }]
      }),
      value: 'font'
    }],
    multiple: true
  }, {
    id: 'authors',
    component: 'select',
    name: 'authors',
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "7oXkoj",
      defaultMessage: [{
        "type": 0,
        "value": "Authors"
      }]
    }),
    requestUrl: route('medias.authors') || '/medias/authors',
    itemLabelPath: 'name',
    itemValuePath: 'id',
    multiple: true,
    paginated: false
  }, {
    id: 'tags',
    component: 'select',
    name: 'tags',
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "9mXl24",
      defaultMessage: [{
        "type": 0,
        "value": "Tags"
      }]
    }),
    requestUrl: route('medias.tags') || '/medias/tags',
    itemLabelPath: 'name',
    itemValuePath: 'name',
    multiple: true,
    paginated: false
  }, {
    id: 'source',
    component: 'radios',
    name: 'source',
    options: [{
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "bCtuS/",
        defaultMessage: [{
          "type": 0,
          "value": "In this Micromag"
        }]
      }),
      value: 'document-'
    }]
  }];
}

var styles = {"container":"micromag-media-gallery-new-media-gallery-container","browser":"micromag-media-gallery-new-media-gallery-browser"};

var propTypes = {
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  types: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  source: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),
  fields: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),
  isPicker: PropTypes.bool,
  multiple: PropTypes.bool,
  medias: PropTypes$1.medias,
  onChange: PropTypes.func,
  onMediaFormOpen: PropTypes.func,
  onMediaFormClose: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  types: null,
  source: 'all',
  filters: null,
  fields: null,
  columns: defaultColumns,
  isPicker: false,
  multiple: false,
  medias: null,
  onChange: null,
  onMediaFormOpen: null,
  onMediaFormClose: null,
  className: null
};
function MediaGallery(_ref) {
  var value = _ref.value,
    types = _ref.types,
    source = _ref.source,
    filters$1 = _ref.filters,
    providedFields = _ref.fields,
    columns = _ref.columns,
    isPicker = _ref.isPicker,
    multiple = _ref.multiple,
    initialMedias = _ref.medias,
    onChange = _ref.onChange,
    onMediaFormOpen = _ref.onMediaFormOpen,
    onMediaFormClose = _ref.onMediaFormClose,
    className = _ref.className;
  var api = useApi();
  var story = useStory();
  var _ref2 = story || {},
    _ref2$id = _ref2.id,
    storyId = _ref2$id === void 0 ? null : _ref2$id;
  var fields$1 = providedFields === null ? fields() : providedFields;
  var mediasApi = useMemo(function () {
    return {
      get: function get() {
        var _api$medias;
        return (_api$medias = api.medias).get.apply(_api$medias, arguments);
      },
      getTrashed: function getTrashed() {
        var _api$medias2;
        return (_api$medias2 = api.medias).getTrashed.apply(_api$medias2, arguments);
      },
      find: function find() {
        var _api$medias3;
        return (_api$medias3 = api.medias).find.apply(_api$medias3, arguments);
      },
      create: function create() {
        var _api$medias4;
        return (_api$medias4 = api.medias).create.apply(_api$medias4, arguments);
      },
      update: function update() {
        var _api$medias5;
        return (_api$medias5 = api.medias).update.apply(_api$medias5, arguments);
      },
      replace: function replace() {
        var _api$medias6;
        return (_api$medias6 = api.medias).replace.apply(_api$medias6, arguments);
      },
      "delete": function _delete() {
        var _api$medias7, _api$medias8;
        return typeof api.medias.forceDelete !== 'undefined' ? (_api$medias7 = api.medias).forceDelete.apply(_api$medias7, arguments) : (_api$medias8 = api.medias)["delete"].apply(_api$medias8, arguments);
      },
      // TODO: Temporary compat... see how this works
      trash: function trash() {
        var _api$medias9;
        return (_api$medias9 = api.medias)["delete"].apply(_api$medias9, arguments);
      },
      restore: function restore() {
        var _api$medias0;
        return (_api$medias0 = api.medias).restore.apply(_api$medias0, arguments);
      }
    };
  }, [api]);

  // Upload
  var _useMediaCreate = useMediaCreate(),
    createMedia = _useMediaCreate.create;
  var onMediaUploaded = useCallback(function (newMedias) {
    return Promise.all(newMedias.map(createMedia)).then(function (newAddedMedias) {
      return newAddedMedias;
    });
  }, [createMedia]);
  var fileTypes = useMemo(function () {
    var finalTypes = [];
    if (isArray(types)) {
      finalTypes = types.map(function (t) {
        return ['image', 'video', 'audio'].indexOf(t) !== -1 ? "".concat(t, "/*") : null;
      }).filter(function (t) {
        return t !== null;
      });
    }
    finalTypes = ['image', 'video', 'audio'].indexOf(types) !== -1 ? ["".concat(types, "/*")] : null;
    if (finalTypes !== null && isArray(finalTypes) && finalTypes.indexOf('video/*') !== -1) {
      finalTypes.push('image/gif');
    }
    return finalTypes;
  }, [types]);
  var uppyConfig = useMemo(function () {
    return {
      // set sources ? - uppy sources -
      allowedFileTypes: fileTypes !== null && fileTypes.length > 0 ? fileTypes : null
    };
  }, [fileTypes]);
  var finalTypes = useMemo(function () {
    return !isArray(types) && types !== null ? [types] : types;
  }, [types]);

  // Filters
  var partialFilters = filters$1 || filters() || [];
  var finalFilters = useMemo(function () {
    return partialFilters.map(function (filter) {
      var _ref3 = filter || {},
        _ref3$id = _ref3.id,
        id = _ref3$id === void 0 ? null : _ref3$id,
        _ref3$options = _ref3.options,
        options = _ref3$options === void 0 ? [] : _ref3$options;
      if (id === 'types' && finalTypes !== null) {
        return false;
      }
      if (id === 'source') {
        if (storyId === null) {
          return null;
        }
        return _objectSpread(_objectSpread({}, filter), {}, {
          options: (options || []).map(function () {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              _ref4$value = _ref4.value,
              optionValue = _ref4$value === void 0 ? null : _ref4$value,
              _ref4$label = _ref4.label,
              label = _ref4$label === void 0 ? null : _ref4$label;
            return optionValue === 'document-' ? {
              value: "document-".concat(storyId),
              label: label
            } : {
              value: optionValue,
              label: label
            };
          })
        });
      }
      return filter;
    }).filter(function (f) {
      return f !== null;
    });
  }, [partialFilters, storyId]);
  var _useState = useState(source !== null ? {
      source: source
    } : null),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var finalQuery = useMemo(function () {
    setQuery(_objectSpread(_objectSpread({}, query || null), source !== null ? {
      source: source
    } : null));
  }, [source, setQuery]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className)])
  }, isPicker ? /*#__PURE__*/React.createElement(MediasPickerContainer, {
    className: styles.browser,
    api: mediasApi,
    value: value,
    theme: "dark",
    types: finalTypes,
    query: finalQuery,
    items: initialMedias,
    filters: finalFilters,
    fields: fields$1,
    columns: columns,
    multiple: multiple,
    onChange: onChange,
    uppyConfig: uppyConfig,
    onMediaUploaded: onMediaUploaded,
    onMediaFormOpen: onMediaFormOpen,
    onMediaFormClose: onMediaFormClose,
    withStickySelection: true,
    withTrash: true
  }) : /*#__PURE__*/React.createElement(MediasBrowserContainer, {
    className: styles.browser,
    api: mediasApi,
    value: value,
    theme: "dark",
    types: finalTypes,
    query: finalQuery,
    items: initialMedias,
    filters: finalFilters,
    fields: fields$1,
    columns: columns,
    uppyConfig: uppyConfig,
    onMediaUploaded: onMediaUploaded,
    multipleSelection: true // allow multi-uploads in MediasBrowser
    ,
    withStickySelection: true,
    withTrash: true,
    withReplace: true
  }));
}
MediaGallery.propTypes = propTypes;
MediaGallery.defaultProps = defaultProps;

export { MediaGallery as default };
